module.exports = __webpack_public_path__ + "imgs/star-full-circled-yellow.88805630495740c0fe4f1989778dec3e.svg";